// eslint-disable-next-line no-undef
class ProductSwatches extends HTMLElement {
  connectedCallback() {
    this.swatchesList = this.querySelector(".dropdown-colors__swatches");
    this.optionContainer = this.querySelector(".js-dropdown-colors");

    if (this.getAttribute('redirect') !== 'false') {
      this.triggerColor();
    }
    this.validateSwatches();

    if (this.dataset.fetchSwatches === 'true') {
      this.initListeners();
    }
  }

  async fetchSwatches() {
    if (this.dataset.fetchSwatches !== 'true') {
      return;
    }

    let data = null;
    const tag = this.getAttribute("sku");
    const styleTag = this.dataset.styleTag || '';
    const url = `${window.location.origin}/search?view=variants-products&q=${styleTag}${tag}`;
    const cache = window.swatchesCache || {};
    if (cache[url]) {
      data = cache[url];
    }

    if (!data) {
      data = await window
        .fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .catch((error) => console.error("Error fetching swatches:", error));
    }

    window.swatchesCache = window.swatchesCache || {};
    window.swatchesCache[url] = data;
    const parser = new DOMParser();
    const html = parser.parseFromString(data, "text/html");
    const fragment = document.createDocumentFragment();
    html.querySelectorAll("li[data-id]").forEach((item) => {
      fragment.appendChild(item);
    });
    if (this.swatchesList) this.swatchesList.appendChild(fragment);
    this.validateSwatches();
    this.redirectColorsEvents();
    if (this.getAttribute('redirect') !== 'false') {
      this.triggerColor();
    }
  }

  redirectColorsEvents() {
    const redirect = this.getAttribute("redirect");
    if (redirect != "false") return;
    const redirectLinks = this.querySelectorAll(".swatches__link");
    if (!redirectLinks) return;
    redirectLinks.forEach((redirectLink) => {
      redirectLink.addEventListener("click", (event) => {
        event.preventDefault();
        const url = redirectLink.href;
        const eventProductChange = new CustomEvent("product-change", {
          detail: redirectLink.dataset.handle,
          bubbles: true,
        });

        redirectLink.dispatchEvent(eventProductChange);
      });
    });
  }

  triggerColor() {
    const selectedLink = this.querySelector(
      ".selected .swatches__link:not(.swatches__link--redirect)"
    );
    if (selectedLink) {
      selectedLink.click();
    }
  }

  validateSwatches() {
    const ids = new Set();
    let hasColors = false;
    if (this.swatchesList) this.swatchesList.querySelectorAll("li").forEach((item) => {
      const id = item.getAttribute("data-id");
      if (!item.classList.contains("hidden")) {
        hasColors = true;
      }
      if (ids.has(id)) {
        item.remove();
      } else {
        ids.add(id);
      }
    });
    if (!hasColors) {
      if (this.optionContainer) this.optionContainer.classList.add("hidden");
    } else {
      if (this.optionContainer) this.optionContainer.classList.remove("hidden");
    }
  }

  initListeners() {
    if (this.dataset.fetchSwatches !== 'true') {
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.fetchSwatches();
          this.observer.disconnect();
        }
      });
    }, {
      rootMargin: "500px 0px 500px 0px",
      threshold: 0
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
window.customElements.define("product-swatches", ProductSwatches)
